import { fNumber } from 'common/utils/formatNumber'

import { Box, Grid, Typography, useTheme } from '@mui/material'

interface FoodCardProps {
  icon: React.ElementType
  label: string
  value: number
  unit?: string
  isPercentage?: boolean
  padding?: number
  textSize?: number
  numberSize?: number
  unitSize?: number
  children?: React.ReactNode
  disabledColor?: boolean
}

const FoodCard: React.FC<FoodCardProps> = ({
  icon: Icon,
  label,
  value,
  unit,
  isPercentage,
  padding = 2,
  textSize = 18,
  numberSize = 40,
  unitSize = 22,
  children,
  disabledColor = false,
}) => {
  const theme = useTheme()
  const color = disabledColor
    ? undefined
    : isPercentage
    ? value < 0
      ? theme.palette.error.main
      : value > 0
      ? theme.palette.primary.main
      : undefined
    : theme.palette.primary.main

  return (
    <Grid item xs={12} md={4}>
      <Box
        sx={{
          borderRadius: 3,
          border: '1px solid',
          borderColor: theme.palette.primary.main,
          p: padding + 1,
          pb: padding,
          gap: 2,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 2,
            height: '100%',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              width: '48px',
              minWidth: '48px',
              height: '48px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 1.5,
            }}
          >
            <Icon sx={{ fontSize: 20, color: 'white' }} />
          </Box>

          <Box textAlign="right">
            <Typography mb={1} fontSize={textSize} color={theme.palette.grey[600]}>
              {label}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 1,
                lineHeight: 1,
                color,
                textAlign: 'right',
              }}
            >
              <Typography fontSize={numberSize} fontWeight={600} mb={1} noWrap>
                {isPercentage && value > 0 && '+'}
                {fNumber(value)} {isPercentage ? '%' : ''}
              </Typography>
              {unit && (
                <Typography fontSize={unitSize} fontWeight={600}>
                  {unit}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

        {children && <Box mt={1}>{children}</Box>}
      </Box>
    </Grid>
  )
}

export default FoodCard
